import { Box, SxProps, Typography } from '@mui/material';
import { ComponentType, ReactNode } from 'react';

import { useSxStyles } from '~/scenes/PortalModules/User/UserSettings/components/UserSettingsCard/useStyles';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

type PropsType = {
  title?: string;
  loading?: boolean;
  error?: ReactNode;
  Icon: ComponentType<{ sx: SxProps }>;
  actions?: ReactNode;
  children: ReactNode;
};

export const UserSettingsCard = (props: PropsType) => {
  const { title, Icon, loading, error, actions, children } = props;

  const sxStyles = useSxStyles();

  return (
    <Box sx={sxStyles.cardContainer}>
      <Box sx={sxStyles.iconContainer}>
        <Icon sx={sxStyles.icon} />
      </Box>
      <Box sx={sxStyles.content}>
        {!!title && <Typography sx={sxStyles.header}>{title}</Typography>}
        {loading ? <LoadingView /> : <>{!!error ? error : children}</>}
        {!!actions && <Box sx={sxStyles.actions}>{actions}</Box>}
      </Box>
    </Box>
  );
};
